import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompaniesFailure(err?.response?.data));
  }
}

export function* handleFetchCatalog({ payload }) {
  try {
    const res = yield call(API.fetchCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCatalogFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyUsers({ payload }) {
  try {
    const res = yield call(API.fetchCompanyUsers, payload);
    const { data } = res;
    yield put(actions.fetchCompanyUsersSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyUsersFailure(err?.response?.data));
  }
}

export function* handleFetchUser({ payload }) {
  try {
    const res = yield call(API.fetchUserDetails, payload);
    const { data } = res;
    yield put(actions.fetchUserSuccess(data));
  } catch (err) {
    yield put(actions.fetchUserFailure(err?.response?.data));
  }
}

export function* handleCreatePackage({ payload }) {
  try {
    const res = yield call(API.createDirectOrder, payload);
    const { data } = res;
    yield put(actions.createOrderSuccess(data));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.createOrderFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.createOrderFailure(err?.response?.data));
    if (payload.onFailure) payload.onFailure();
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchCommoditiesForCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}
export function* handleFetchTests({ payload }) {
  try {
    const res = yield call(API.fetchTestsForCommodityCatalog, payload);
    const { data } = res;
    yield put(actions.fetchTestsSuccess(data));
  } catch (err) {
    yield put(actions.fetchTestsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* bookTestSaga() {
  yield takeLatest(actions.fetchCompanies.type, handleFetchCompanies);
  yield takeLatest(actions.fetchCatalog.type, handleFetchCatalog);
  yield takeLatest(actions.fetchUser.type, handleFetchUser);
  yield takeLatest(actions.createOrder.type, handleCreatePackage);
  yield takeLatest(actions.fetchCompanyUsers.type, handleFetchCompanyUsers);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchTests.type, handleFetchTests);
}
